import * as actionTypes from '../actionTypes/gupshupWhatsapp';

export function checkCurrentWhatsappStatus() {
    return { type: actionTypes.CHECK_CURRENT_WHATSAPP_OPTIN_STATUS };
}

export function setCurrentWhatsappStatus(status, isUserAction) {
    return { type: actionTypes.SET_WHATSAPP_OPTIN_STATUS, status, isUserAction };
}
